import { takeEvery, put, call } from 'redux-saga/effects';
import { Creators, Types } from 'src/store/redux/statistics-me/actions';
import statisticsAPI from 'src/services/api/statistics';
import { handleErrorResponse } from 'src/lib/helpers/errors';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* getPerscAnalytics(filters: any = null) {
  try {
    // @ts-ignore: Unreachable code error
    
    const response = yield call(statisticsAPI.perscAnalyticsStats, filters);
    yield put(
      Creators.statisticsMePerscAnalyticsRequestSuccess(response.data)
    );
  } catch (e) {
    let error = e;
    DBErrorMonitor.captureException(e, {
      saga: 'getPerscAnalytics',
      entity: 'statistics',
    });
    handleErrorResponse(error);
    yield put(Creators.statisticsMePerscAnalyticsRequestError(error));
  }
}

export function* watchGetPerscAnalytics() {
  yield takeEvery(
    Types.STATISTICS_ME_PERSC_ANALYTICS_REQUEST,
    getPerscAnalytics
  );
}

export default watchGetPerscAnalytics;
